import type { ConversationQuickReply } from '../../../services/conversationQuickReplies';

export interface QuickReplyCategoryGroup {
    category: string;
    replies: ConversationQuickReply[];
}

// The API already orders by category, so groups are runs of the same category.
export function groupByCategory(replies: ConversationQuickReply[]): QuickReplyCategoryGroup[] {
    return replies.reduce<QuickReplyCategoryGroup[]>((groups, reply) => {
        const last = groups[groups.length - 1];
        if (last?.category !== reply.category) {
            return [...groups, { category: reply.category, replies: [reply] }];
        }
        return [...groups.slice(0, -1), { ...last, replies: [...last.replies, reply] }];
    }, []);
}
